import { useAuthRuntime } from "@frontend/components/auth/auth-runtime"
import { useEffect, useState } from "react"

export function useMaterialImageUrl(caseId: string, materialId: string): string | null {
  const { getAccessToken } = useAuthRuntime()
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    let objectUrl: string | null = null
    let cancelled = false

    async function fetchImage() {
      const token = await getAccessToken()
      const res = await fetch(`/api/cases/${caseId}/supporting-materials/${materialId}/file`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      })
      if (cancelled || !res.ok) return

      const blob = await res.blob()
      if (cancelled) return

      objectUrl = URL.createObjectURL(blob)
      setUrl(objectUrl)
    }

    fetchImage()

    return () => {
      cancelled = true
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl)
      }
    }
  }, [caseId, materialId, getAccessToken])

  return url
}
